import { render, staticRenderFns } from "./search-input-header.vue?vue&type=template&id=7bc42a66&"
import script from "./search-input-header.vue.ts?vue&type=script&lang=ts&"
export * from "./search-input-header.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports